import { Typography } from '@mui/material';
import { Channel, ChannelList, Thread, Window, useChatContext } from 'stream-chat-react';
import type { ChannelFilters, ChannelOptions, ChannelSort } from 'stream-chat';
import CustomMessageInput from './CustomMessageInput';
import { CustomChannelPreview } from './CustomChannelPreview';
import ChannelLayoutManager from './ChannelLayoutManager';
import { ChannelSearch } from './ChannelSearch';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { Dispatch, SetStateAction } from 'react';
import { LayoutStage } from './StreamChat';
import { useTranslation } from 'react-i18next';
import StreamChatBodyPhone from './StreamChatBodyPhone';
import CustomChannelHeader from './CustomChannelHeader';
import { getLatestMessagePreview } from './ChatUtils';
import CustomMessageList from './CustomMessageList';
import MessageSearchBar from './StreamSearchPanel';

const sort: ChannelSort = [{ last_message_at: -1 }, { name: 1 }];
const options: ChannelOptions = {
  limit: 20,
};

export default function StreamChatBody({
  layout,
  setLayout,
}: {
  layout: LayoutStage;
  setLayout: Dispatch<SetStateAction<LayoutStage>>;
}) {
  const { t } = useTranslation();
  const { client } = useChatContext();

  if (!client) return <div className="no-chat-container">{t('streamChat.custom.setUpClient')}</div>;

  const userId = client.user?.id;
  if (!userId) {
    return;
  }
  const filters: ChannelFilters = {
    members: { $in: [userId] },
  };

  function ChannelBody() {
    return (
      <>
        <Window>
          <CustomChannelHeader setLayout={setLayout} />
          <CustomMessageList />
          <CustomMessageInput />
        </Window>
        {layout === 'search' && <MessageSearchBar setLayout={setLayout} />}
        {layout !== 'search' && <Thread autoFocus={false} additionalMessageInputProps={{ minRows: 1, maxRows: 6 }} />}
      </>
    );
  }

  if (isPhoneOrHighScreen()) {
    return (
      <StreamChatBodyPhone filters={filters} sort={sort} options={options} layout={layout} setLayout={setLayout} />
    );
  }

  return (
    <>
      <div className="stream-chat-body-list-desktop">
        <Typography variant="h6" sx={{ pt: 1 }}>
          {t('chat.latestMessages')}
        </Typography>
        <ChannelSearch />
        <ChannelList
          Preview={(props) => <CustomChannelPreview {...props} setActiveView={setLayout} />}
          getLatestMessagePreview={getLatestMessagePreview}
          filters={filters}
          sort={sort}
          options={options}
          setActiveChannelOnMount={false}
        />
      </div>
      <Channel>
        <ChannelLayoutManager layout={layout} setLayout={setLayout}>
          <ChannelBody />
        </ChannelLayoutManager>
      </Channel>
    </>
  );
}
